export const isNullForm = (value) => {
    return value === undefined || value == null || value === ""
}

export const isNull: Boolean = (value) => {
    if (typeof (value) === undefined || value == null) {
        return true
    } else if (typeof (value) === "string") {
        // if (value.trim().length <= 0) {
        //     return true
        // }
        return value.trim().length <= 0
    } else {
        return false
    }
    // return typeof (value) === undefined || value === null || value.trim().length === 0
}